import * as Common from '@/tenant/common';
import { Conversion } from './Conversion';
import Vue from 'vue';
import { WorkflowQuery } from '@/agiles/common';

export class Commodity extends Common.MasterBase{
  constructor(){
    super('Commodity')
    this.binders.conversions = new Common.ModelBinder(Conversion);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public id: number = 0;
  public code: string = '';
  public name: string='';
  public name2: string='';
  public name3: string='';
  public model: string = '';
  public manufacturer: string = '';
  public uom: string ='';
  public netWeight: number = 0;
  public grossWeight: number = 0;
  public measurement: number = 0;
  public supplierId: number = 0;
  public supplier: Common.Counterpart = null;
  public countryOfOrigin: string = "";
  public minimumStockQuantity: number = 0;
  public replenishmentQuantity: number = 0;
  public replenishmentUomCode: string = null;
  public replenishmentUom: Common.Conversion = null; // クライアント側表示用荷姿

  public set replenishmentUom2(conv : Common.Conversion){
    this.replenishmentUom = conv;
    if(conv == null || conv.code == null) this.replenishmentUomCode = null;
    else this.replenishmentUomCode = conv.code;
  }
  public get replenishmentUom2(): Common.Conversion{
    if(this.replenishmentUom == null) return this.getDefaultConversion();
    return this.replenishmentUom;
  }
  public salesTaxCode: string = null;
  public purchaseTaxCode: string = null;
  public quantityScale: number = 0;
  public quantityRound: Common.RoundTypes = Common.RoundTypes.RoundMidpoint;
  public stockPriceScale: number = 0;
  public stockPriceRound: Common.RoundTypes = Common.RoundTypes.RoundMidpoint;

  // その他設定
  public isNoStock: boolean = false;
  public priceType: SalesPricingTypes = Common.SalesPricingTypes.PricingRate;
  public priceTypePurchase: PurchasePricingTypes = Common.PurchasePricingTypes.CommodityMaster;
  public sellingPrice: number = 0;
  public purchasePrice: number = 0;
  public description: string = '';
  public ecFlag: Common.ECFlags = Common.ECFlags.None;
  public get ecFlag2() { return this.ecFlag;}
  public set ecFlag2(value: Common.ECFlags) {this.ecFlag = value; this.ecBaseId = null;}
  public ecBaseId:string = null;

  // その他設定2
  public deliveryFlag:Common.DeliveryFlags = 0;
  public noPurchaseFlg:boolean = false;

  // 予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;

  // 区分
  public categoryCode1: number = null;
  public categoryCode2: number = null;
  public categoryCode3: number = null;
  public categoryCode4: number = null;
  public categoryCode5: number = null;
  public categoryCode6: number = null;

  // 商品画像
  public imageDescription: string = '';

  public copy():any {
    const temp = super.copy() as Commodity;
    temp.id = 0;
    temp.code = null;    
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }

  public getDefaultConversion(): Common.Conversion {
    var conversion : Common.Conversion;
    conversion = new Common.Conversion();
    conversion.commodityId = this.id;
    conversion.code = null;
    conversion.name = this.uom;
    conversion.rate = 1;
    conversion.netWeight = this.netWeight;
    conversion.grossWeight = this.grossWeight;
    conversion.measurement = this.measurement;
    return conversion;
  }
}

export enum SalesPricingTypes
{
  PriceMaster = 0,
  PricingRate = 1,
}
export enum PurchasePricingTypes
{
  CommodityMaster = 0,
  PriceMaster = 1,
}

export class CommodityQuery extends Common.LoadQuery {
  constructor(){
    super('CommodityQuery',Commodity);
    this.sort = 'code';
  }

  public code: string = '';
  public name: string = '';
  public barcode: string = '';
  public model: string = '';
  public isNoStock: boolean = null;
  public categoryCode1: number = null;
  public categoryCode2: number = null;
  public categoryCode3: number = null;
  public categoryCode4: number = null;
  public categoryCode5: number = null;
  public categoryCode6: number = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class CommodityMasterQuery extends Common.LoadQuery {
  constructor(){
    super('CommodityMasterQuery',Commodity);
  }
}

/**ライセンスフラグ値を取得します。 */
export class CommodityChildItemQuery extends Common.Query {
  constructor(commodity: Common.Commodity){
    super('CommodityChildItemQuery',new Common.ModelBinder(CommodityChildItemResult,false)); 
    this.commodity = commodity;
  }
  public commodity : Common.Commodity;
}

export class CommodityChildItemResult extends Common.ObjectBase {
    constructor(){
      super('CommodityChildItemResult');
    }
    public hasConversionItems : boolean;
    public hasSkuItems:boolean;
    public hasPriceItems: boolean;    
    public hasShelfNoItems:boolean;
}

export class CommodityScheduleQuery extends Common.Query {
  constructor(warehouse: Common.Counterpart, commodityCode: string, skuCode : string = null){
    super('CommodityScheduleQuery',new Common.ModelBinder(CommodityScheduleResult,false)); 
    this.commodityCode = commodityCode;
    this.skuCode = skuCode;
    this.warehouseId = warehouse ? warehouse.id : null;
  }
  public commodityCode : string;
  public skuCode : string;    
  public warehouseId : number;
}
export class CommodityScheduleQuery2 extends Common.Query {
  constructor(stockDate: Date, commodityCode: string, skuCode : string = null){
    super('CommodityScheduleQuery2',new Common.ModelBinder(CommoditySchedule,false)); 
    this.stockDate = stockDate;
    this.commodityCode = commodityCode;
    this.skuCode = skuCode;
  }
  public stockDate: Date;
  public commodityCode : string;
  public skuCode : string;    
  public warehouseId : number;
  public segmentId : number;
}
export class CommoditySchedule extends Common.ObjectBase{
    constructor(){
      super('CommoditySchedule');
      this.binders.items = new Common.ModelBinder(Common.CommodityScheduleResult, true);
    }  
    public items : Common.CommodityScheduleResult[];
    public salesOrderBacklog :number = 0;
    public purchaseOrderBacklog :number = 0;    
}
export class CommodityScheduleResult extends Common.ObjectBase {
    constructor(){
      super('CommodityScheduleResult');
    }
    public  stockQuantity :number = 0;
    public  salesOrderBacklog :number = 0;
    public  purhcaseOrderBacklog :number = 0;
    public  salesDeliveryBacklog  :number = 0;
    public  purchaseDeliveryBacklog  :number = 0;
    public  scheduledQuantity :number = 0;
    public  uom: string = '';
    public stockClosingDate: Date=null;
}

export class CommodityCodeQuery extends Common.Query {
  constructor(commodityCode: string){
    super('CommodityCodeQuery',new Common.ModelBinder(Commodity,false)); 
    this.commodityCode = commodityCode;
  }
  public commodityCode : string;  
}

export class SKUCodeQuery extends Common.Query {
  constructor(commodityCode: string,skuCode : string){
    super('SKUCodeQuery',new Common.ModelBinder(Common.SKU,false)); 
    this.commodityCode = commodityCode;
    this.skuCode = skuCode;    
  }
  public commodityCode : string;  
  public skuCode : string;      
}

export class QueryParamUtility {
  public static async loadQueryParams(to:any, from:any, next:Function){
      //thisが使えないためVue.prototypeからapiを取得
    var api = Vue.prototype.$api as Common.Api;
    //ここでinitializeするとApp側のPromiseが正常に動作しない。commodityCode指定でリロードするとうまくいかない。
    // await api.initialize();

    //リロードの場合は待つ
    if (api.initialized == false){
      await api.waitInitialized();
    }
    if (to.query.commodityCode && to.query.skuCode){
        await api.execute(new Common.SKUCodeQuery(to.query.commodityCode as string,to.query.skuCode as string)).then(res =>{
          to.query.sku = res as Common.SKU;                           
        });
    }

    if (to.query.commodityCode) {
        await api.execute(new Common.CommodityCodeQuery(to.query.commodityCode as string)).then(res =>{  
          to.query.commodity = res as Common.Commodity;
        });    
    } 
    
    if (to.query.workflowId) {
      var query = new WorkflowQuery();
      query.id = to.query.workflowId;
      await api.execute(query).then((res : Common.LoadResult) =>{  
        if (res.records == 1){
          var obj = res.result[0];
          to.query.workflow = obj;
        }
      });          
    }


    next();
  }
}

export class CommodityImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "CommodityImportQuery";
    this.sheetName = sheetName;
    this.hasLicenseTrade = false;
  }
  public sheetName: string;
  public hasLicenseTrade: boolean;
}

export class CommodityExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "CommodityExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.hasLicenseTrade = false;
  }
  public loadQuery: Common.LoadQuery;
  public sheetName: string;
  public hasLicenseTrade: boolean;
}